// extracted by mini-css-extract-plugin
module.exports = {"filtersList":"styles_filtersList__3PyQj","filter_item":"styles_filter_item__14ES8"};